

















































































































































import {CustomBulkDistrItemImpl} from "@/store/user_management/distr_moderation/types";
import {Vue, Component, Ref} from "vue-property-decorator";
import { Action } from "vuex-class";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {removeItem} from "@/utils/data-helper";
import {InputWings, TextareaWings} from "wings-ui-components";

@Component({components: {InputWings, TextareaWings}})
export default class CustomDistribution extends Vue {
  @Action("getBulkDistrItem") actionGetDistributionItem: any;
  @Action("actionLog") actionLog: any;
  @Ref('validatorUserOptions') validatorUserOptions: any;

  private distribution = new CustomBulkDistrItemImpl();
  private logObject: ActionLog = {};
  private selectedItems = [];

 async created() {
   this.distribution.custom_parameters = [{name: 'SAN', value: '123ac45z67'}]
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Distribution",
          addititional_info: getTranslatedParams({channel: this.$route.params.channel, id: this.$route.params.id})
        }
        await this.actionGetDistributionItem(this.$route.params.id).then((data: CustomBulkDistrItemImpl) => {
          this.distribution = Object.assign({}, this.distribution, data);
        });
        await this.actionLog(this.logObject);
      } catch (err){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  onSelect(items: any) {
    this.selectedItems = items;
  }

  async addEmptyItem():Promise<void> {
    let valid:boolean = await this.validatorUserOptions.validate();
    if (valid){
      if (this.distribution.custom_parameters === undefined) {
        this.distribution.custom_parameters = [];
      }
      this.distribution.custom_parameters.push({name: undefined, value: undefined});
    }
  }

  deleteSelectedItem(): void {
    if (this.distribution.custom_parameters) {
      this.selectedItems.forEach((item: any) =>
          removeItem(this.distribution.custom_parameters, item));
    }
    if (this.distribution.custom_parameters?.length === 0) {
      this.addEmptyItem();
    }
  }
}
